import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PQRInfraestruturaPrediosEscolaresDto } from '../../dtos/pqr-infraestrutura-predios-escolares.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRInfraestruturaPrediosEscolares {
  _embedded: {
    'pqr-infraestrutura-predio-escolar': PQRInfraestruturaPrediosEscolaresDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRInfraestruturaPrediosEscolaresService {
  private apiUrl = `${environment.apiUrl}/pqr-infraestrutura-predio-escolar`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRInfraestruturaPrediosEscolares(): Observable<PQRInfraestruturaPrediosEscolaresDto[]> {
    return this.caqRequestService
      .get<ListPQRInfraestruturaPrediosEscolares>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-infraestrutura-predio-escolar']));
  }
}
